<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Group Sharing</b>
        <b-button
          v-show="hasGroups"
          v-if="isOrgAdmin && hasMoreGroupsToShareWith"
          disabled
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
        >
          <span class="button-text">Share with</span>
        </b-button>
      </b-card-header>

      <!-- List groups -->
      <div v-if="shareAssessmentRecords.length > 0">
        <b-list-group v-for="sp in shareAssessmentRecords" :key="sp.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent="toggleUpdateShareAssessmentModal(sp.id)">
              {{ _.get(sp, 'sgroup.groupName', 'Unknown') }} <img :src="'/static/img/' + (sp.assessmentShareStatus ? 'shareYes.png' : 'shareNo.png')" height="21" width="21">
            </a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="shareAssessmentRecords.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>{{ !hasGroups ? 'Your organization does not belong to any groups' : 'This record is not currently shared' }}</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- View/Update Existing -->
    <UpdateShareAssessmentModal
      :assessmentId="assessmentId"
      :assessmentOrganizationOwner="assessmentOrganizationOwner"
      :shareRecord="shareRecord"
      :groupId="selectedGroup"
    ></UpdateShareAssessmentModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateShareAssessmentModal from '@/components/Share/UpdateShareAssessmentModal'

export default {
  name: 'share-assessment-list',
  props: {
    assessmentId: Number,
    assessmentOrganizationOwner: Number,
    personId: Number
  },
  components: {
    UpdateShareAssessmentModal
  },
  data: function () {
    return {
      showUpdateAssessmentModal: false,
      selectedGroup: {},
      shareRecordId: 0
    }
  },
  computed: {
    ...mapGetters({
      shareAssessmentRecords: 'shareAssessmentRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userTransferAllowed: 'userTransferAllowed',
      userCurrentContext: 'userCurrentContext' // Passing user context to determine if they have isOrgAdmin
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    },
    hasMoreGroupsToShareWith: function () {
      let condition = false
      let countGroups = this.getGroupsByOrg.length || 0
      let countShareRecords = this.shareAssessmentRecords.length || 0
      // console.log('hasMoreGroups: countGroups=' + countGroups + ' countShareRecords=' + countShareRecords)
      if (countGroups > countShareRecords) {
        condition = true
      }
      return condition
    },
    isOrgAdmin: function () {
      return this.userTransferAllowed(this.assessmentOrganizationOwner)
    },
    shareRecord: function () {
      return this.shareAssessmentRecords.find((r) => r.id === this.shareRecordId)
    }
  },
  watch: {
    assessmentId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getShareAssessmentRecords', {
          sassessment: newValue,
          populate: 'sgroup'
        })
      }
    }
  },
  methods: {
    toggleUpdateShareAssessmentModal: function (shareRecordId) {
      this.shareRecordId = shareRecordId
      // this.showUpdateAssessmentModal = !this.showUpdateAssessmentModal
      this.$bvModal.show('update-share-assessment')
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'shareAssessmentResponse' })
      this.$store.commit('RESET_SHARE_ASSESSMENT_RECORDS')
    }
  },
  beforeDestroy () {
    this.resetAll()
  },
  created () {
    if (this.assessmentId && _.isInteger(this.assessmentId)) {
      this.$store.dispatch('getShareAssessmentRecords', {
        sassessment: this.assessmentId,
        populate: 'sgroup,sassessment'
      })
      this.$store.dispatch('getGroupsByOrg', { id: this.assessmentOrganizationOwner })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Assessment/ShareAssessmentList.vue